// extracted by mini-css-extract-plugin
module.exports = {"dropActive":"SingleImageCrop_dropActive_2VIHy","fileUploadZoneSmall":"SingleImageCrop_fileUploadZoneSmall_3mTZK","fileUploadZone":"SingleImageCrop_fileUploadZone_smi5B"};